export type SiteId = string;

export type HighlightId = string;

const API_ROOT = '/api/{version}/sites';

export function getPath(siteId: SiteId, version = 'v1'): string {
  const root = API_ROOT.replace('{version}', version);
  return `${root}/${siteId}/highlights`;
}
